export const PlayState = Object.freeze({
    Undefined: 'undefined',
    Stopped: 'stopped',
    Paused: 'paused',
    Playing: 'playing',
    ScanForward: 'scanforward',
    ScanReverse: 'scanreverse',
    Buffering: 'buffering',
    Waiting: 'waiting',
    MediaEnded: 'mediaended',
    Transitioning: 'transitioning',
    Ready: 'ready',
    Reconnecting: 'reconnecting',
    Closed: 'closed',
    Error: 'error',
    Opening: 'opening'
});

export const PlayerState = Object.freeze({
    NotReady: 'NotReady',
    InteractionRequired: 'InteractionRequired',
    Waiting: 'Waiting',
    Playing: 'Playing',
    Paused: 'Paused',
    Stopped: 'Stopped',
    Ended: 'Ended',
    Error: 'Error'
});

export const ErrorCode = Object.freeze({
    MethodNotFound: 410,
    MethodError: 411,
    //    LoadManifestFailure: 500,
    MediaError: 510, // Todo
    MediaNotSupported: 511, // Todo
    PlayerNotReady: 520, // Todo
    MediaPlayFailed: 530 // Todo
});

export const ErrorDescription = Object.freeze({
    410: "API method not found",
    411: "Error while calling API method",
    500: "Could not load presentation metadata",
    510: "Problem with presentation media",
    511: "Presentation media is not supported",
    520: "Player not ready",
    530: "Play was rejected by media element"
});
